import { Timestamp } from 'firebase/firestore';

/**
 * 퍼스널힐링데이 사용 기록
 *
 * Firestore: personalHealingDays 컬렉션
 *
 * 분기별 퍼스널힐링데이 사용 내역을 추적합니다.
 */
export interface PersonalHealingDay {
  /** 문서 ID */
  id: string;

  /** 직원 ID */
  employeeId: string;

  /** 직원 이름 */
  employeeName: string;

  /** 연도 */
  year: number;

  /** 분기 (1~4) */
  quarter: number;

  /** 사용 여부 */
  isUsed: boolean;

  /** 사용일 (YYYY-MM-DD) */
  usedDate?: string;

  /** 휴가 신청 ID (참조용) */
  leaveRequestId?: string;

  /** 생성 일시 */
  createdAt: Timestamp;

  /** 수정 일시 */
  updatedAt?: Timestamp;
}

/**
 * 퍼스널힐링데이 사용 입력
 */
export interface PersonalHealingDayInput {
  /** 직원 ID */
  employeeId: string;

  /** 연도 */
  year: number;

  /** 분기 */
  quarter: number;

  /** 사용일 */
  usedDate: string;

  /** 휴가 신청 ID */
  leaveRequestId: string;
}

/**
 * 분기 계산 유틸
 *
 * @param date YYYY-MM-DD 형식의 날짜
 * @returns 분기 (1~4)
 */
export function getQuarterFromDate(date: string): number {
  const month = parseInt(date.split('-')[1], 10);
  if (month >= 1 && month <= 3) return 1;
  if (month >= 4 && month <= 6) return 2;
  if (month >= 7 && month <= 9) return 3;
  return 4;
}

/**
 * 분기 라벨
 */
export const QUARTER_LABELS: Record<number, string> = {
  1: '1분기(1월~3월)',
  2: '2분기(4월~6월)',
  3: '3분기(7월~9월)',
  4: '4분기(10월~12월)',
};
